import { useEffect, useState } from "react";
import { api, getAdminToken } from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const pw = () => ({ headers: { Authorization: `Bearer ${getAdminToken()}` } });
const centsToEuros = (c) => (c == null ? "" : (c / 100).toString().replace(".", ","));
const eurosToCents = (v) => {
  const s = String(v).trim().replace(",", ".");
  if (s === "") return null;
  const n = parseFloat(s);
  return isNaN(n) ? null : Math.round(n * 100);
};

export default function AdminCommerce() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);
  const set = (i, patch) => setProducts((ps) => ps.map((p, j) => (j === i ? { ...p, ...patch } : p)));

  const save = async (p) => {
    try {
      const r = await api.put(`/admin/products/${p.key}`, {
        name: p.name, positioning: p.positioning, tagline: p.tagline,
        price_cents: p.price_cents, currency: p.currency || "eur", active: !!p.active,
      }, pw());
      toast.success(`${r.data.name} enregistré`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Échec");
    }
  };

  return (
    <div data-testid="admin-commerce">
      <p className="font-sans text-sm text-[#1F2A24]/60 mb-4">Prix configurables par produit. Laissez le prix vide pour « non défini ». Aucun prix fictif n'est imposé.</p>
      <div className="space-y-3">
        {products.map((p, i) => (
          <div key={p.key} data-testid={`admin-product-${p.key}`} className="rounded-xl bg-white border border-[#E8DCC4] p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="font-serif text-lg text-[#1F2A24]">{p.name}</p>
                <p className="font-serif italic text-sm text-[#1F2A24]/60">{p.positioning}</p>
              </div>
              <label className="flex items-center gap-2 font-sans text-sm"><input type="checkbox" data-testid={`admin-product-active-${p.key}`} checked={!!p.active} onChange={(e) => set(i, { active: e.target.checked })} /> Actif</label>
            </div>
            <textarea rows={2} value={p.tagline || ""} onChange={(e) => set(i, { tagline: e.target.value })} className="w-full mt-3 rounded-xl border border-[#E8DCC4] p-3 font-sans text-sm focus:outline-none focus:ring-2 focus:ring-[#C9A24B]/40" />
            <div className="flex flex-wrap items-end gap-3 mt-3">
              <div>
                <label className="font-sans text-xs uppercase tracking-wider text-[#1F2A24]/60">Prix (€)</label>
                <input data-testid={`admin-product-price-${p.key}`} value={centsToEuros(p.price_cents)} onChange={(e) => set(i, { price_cents: eurosToCents(e.target.value) })} placeholder="—" className="block w-28 mt-1 rounded-full border border-[#E8DCC4] px-4 py-2 font-sans text-sm focus:outline-none focus:ring-2 focus:ring-[#C9A24B]/40" />
              </div>
              <button data-testid={`admin-product-save-${p.key}`} onClick={() => save(p)} className="inline-flex items-center gap-2 rounded-full bg-[#385E3A] text-white px-5 py-2.5 font-ui text-sm hover:bg-[#2c4a2e]"><Save size={15} /> ENREGISTRER</button>
            </div>
          </div>
        ))}
      </div>
      <p className="font-sans text-xs text-[#1F2A24]/45 mt-4">Les offres combinées (bundle, promo, prix de lancement) sont préparées côté serveur et pourront être activées ultérieurement.</p>
    </div>
  );
}
